module.exports = {
  dynamicEnv : process.env.NODE_ENV,
  publicPath : process.env.PUBLIC_PATH
}


// WEBPACK FOOTER //
// ./src/dynamicPaths.js